import { useBilling, useTeamRole } from '@vrplatform/data';
import { Icon } from '@vrplatform/icons';
import {
  EllipsisMenuCopyItem,
  EllipsisMenuDangerItem,
  EllipsisMenuDivider,
  EllipsisMenuItem,
} from '@vrplatform/components-legacy';
import type { Maybe } from '@vrplatform/utils';
import { useExtractModal } from '../../../../modals';
import type { ConnectionRow } from './useConnectionTableQuery';
import { useConnectionConnectModal } from '../../../../drawers';
import { HiddenFeatureIndicator } from '../../../../components';
import { useConnectionDetailDrawer } from '../../../../drawers/connection-drawers/useConnectionDetailDrawer';

export const ConnectionEllipsisMenuItems = ({
  data,
  openRenameModal,
  openDeleteModal,
  openUpdateModal,
}: {
  data: Maybe<ConnectionRow>;
  openRenameModal: () => void;
  openDeleteModal: () => void;
  openUpdateModal: () => void;
}) => {
  const { isReadOnly } = useBilling();
  const { isPartnerAdmin } = useTeamRole();
  const { open: openExtractModal } = useExtractModal();
  const { open: openConnectionDetail } = useConnectionDetailDrawer();

  const { reconnect } = useConnectionConnectModal();

  const id = data?.id;
  const connectionStatus = data?.status || 'active';
  const isArchived = connectionStatus !== 'active';
  const showExtract = !!data?.app.extractors?.length;

  if (!id) return null;

  return (
    <>
      <EllipsisMenuItem
        customIcon={<Icon icon="Edit3Icon" size={16} />}
        onClick={openRenameModal}
      >
        Rename
      </EllipsisMenuItem>
      {!isReadOnly && (
        <>
          <EllipsisMenuItem
            customIcon={<Icon icon="LightningIcon" size={16} />}
            onClick={() => reconnect(id)}
          >
            Reconnect
          </EllipsisMenuItem>
          {showExtract && (
            <EllipsisMenuItem
              customIcon={<Icon icon="RefreshCwIcon" size={16} />}
              onClick={() => {
                openExtractModal({
                  connectionIds: [id],
                  extractType: undefined,
                });
              }}
            >
              Fetch
            </EllipsisMenuItem>
          )}
        </>
      )}
      <EllipsisMenuDivider />
      <EllipsisMenuItem
        onClick={openUpdateModal}
        customIcon={
          <Icon icon={isArchived ? 'RefreshCwIcon' : 'ArchiveIcon'} size={16} />
        }
      >
        {isArchived ? 'Enable' : 'Archive'}
      </EllipsisMenuItem>

      <EllipsisMenuDangerItem
        onClick={openDeleteModal}
        data-testid="connection-delete"
      >
        Delete
      </EllipsisMenuDangerItem>

      {isPartnerAdmin && <EllipsisMenuCopyItem value={id} />}

      <HiddenFeatureIndicator permission="vrp-admin">
        <EllipsisMenuItem
          onClick={() => openConnectionDetail(id)}
          customIcon={<Icon icon={'EyeIcon'} size={16} />}
        >
          Quick view
        </EllipsisMenuItem>
      </HiddenFeatureIndicator>
    </>
  );
};
